module.exports = __webpack_public_path__ + "models/tutor3.abc33e0.atlas";